'use client';

import { useAtom } from 'jotai';
import Image from 'next/image';

import { cn } from '@repo/palette';
import { getImageUrl } from '@repo/utils';

import { registerSuccessAtom } from '@claim/atoms';
import { useClaim } from '@claim/hooks/use-claim';
import { useIsClaimEnded } from '@claim/hooks/use-claim-ended';
import { useIsPreClaimActive } from '@claim/hooks/use-pre-claim-active';

export const DoodHeader: React.FC = () => {
  const { setIsClaiming, setSuccess, success } = useClaim();
  const [registerSuccess, setRegisterSuccess] = useAtom(registerSuccessAtom);
  const isSuccess = success || registerSuccess;

  const preClaimActive = useIsPreClaimActive();
  const isClaimEnded = useIsClaimEnded();

  const handleReset = () => {
    if (!isSuccess) return;
    setRegisterSuccess(false);
    setSuccess(false);
    setIsClaiming(false);
  };

  if (preClaimActive || isClaimEnded) {
    return null;
  }

  return (
    <div className='mx-auto flex w-full max-w-screen-sm items-center justify-between px-6 md:pt-12'>
      <div
        onClick={handleReset}
        className={cn(
          'relative h-auto w-full max-w-[141px]',
          isSuccess ? 'hover:cursor-pointer' : null,
        )}
      >
        <Image
          src={getImageUrl('/claim/images/big-dood.svg')}
          alt='Big Dood'
          layout='responsive'
          width={141}
          height={37}
        />
      </div>

      <Image
        src={getImageUrl('/claim/images/spinny-dood.gif')}
        alt='Spinny Dood'
        width={50}
        height={50}
        className='mb-2 aspect-square h-[50px] w-[50px]'
      />
    </div>
  );
};
